// extracted by mini-css-extract-plugin
export default {"modalDialog":"website_modalDialog__B50Uk","modalContent":"website_modalContent__bpbLm","left":"website_left__1HFT3","right":"website_right__dFBMJ"};